<template>
    <VButton class="proceed-button primary rounded" :disabled="disabled" :ripple="true">
        <div class="pbih action shown"><slot></slot></div>
        <div class="pbih amount shown">{{ toMoneyWithSign(props.currentPrice, props.displayZero) }}</div>
    </VButton>
</template>

<script setup lang="ts">
    import { toMoneyWithSign } from "@/shared/utils/format";

    import VButton from "@/components/elements/VButton.vue";

    // define properties
    const props = defineProps<{
        currentPrice: number;
        displayZero?: boolean;
        disabled?: boolean;
    }>();
</script>

<style lang="scss">
    @use "./../../../assets/styles/scss/shared/_colors.scss";
    @use "./../../../assets/styles/scss/shared/_mixins.scss";

    .proceed-button {
        font-size: 22px;
        position: relative;
        width: 100%;
        height: 2.545em;
        padding: 0;
        overflow: hidden;

        > .pbih {
            position: absolute;
            top: 0;
            bottom: 0;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            transform: translate3d(0, 10px, 0);
            opacity: 0;
            transition: 0.5s cubic-bezier(0.16, 1, 0.3, 1);
            color: colors.$white;
            line-height: 56px;

            &.shown {
                transform: translate3d(0, 0, 0);
                opacity: 1;
            }

            &.animout {
                transform: translate3d(0, -10px, 0);
                opacity: 0;
            }

            &.amount {
                font-size: 20px;
                font-weight: 300;
                text-align: left;
                right: 25px;
            }

            &.action {
                font-size: 22px;
                font-weight: 700;
                text-align: right;
                left: 25px;
                line-height: 50px;
            }
        }
    }
</style>
